import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../../../assets/images/chat/message-pending-timer.png'
import _imports_1 from '../../../../../assets/images/chat/open-eye.svg'
import _imports_2 from '../../../../../assets/images/chat/bicheck-circle.svg'
import _imports_3 from '../../../../../assets/images/chat/close-eye.svg'
import _imports_4 from '../../../../../assets/images/openicon.svg'
import _imports_5 from '../../../../../assets/images/chat/edit-pencil.svg'
import _imports_6 from '../../../../../assets/images/chat/reply.svg'
import _imports_7 from '../../../../../assets/images/chat/delete.svg'
import _imports_8 from '../../../../../assets/images/chat/refresh.png'


const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "edit-msg"
}
const _hoisted_3 = {
  key: 1,
  class: "user-message-body highlight-body"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, "This message has been deleted.", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "text-danger fw-bold ms-3 me-1"
}
const _hoisted_6 = {
  key: 0,
  class: "mx-1"
}
const _hoisted_7 = {
  key: 1,
  class: "text-end"
}
const _hoisted_8 = { class: "d-flex align-items-center justify-content-end w-100" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger me-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "text-danger me-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "d-flex w-100" }
const _hoisted_16 = { class: "message-info reply-message-info" }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = { class: "me-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "message-status" }
const _hoisted_24 = {
  key: 0,
  src: _imports_1,
  class: "status-icon seen-icon",
  title: "Seen by everyone",
  alt: "Seen by everyone"
}
const _hoisted_25 = {
  key: 1,
  src: _imports_2,
  class: "status-icon sent-icon",
  title: "Sent",
  alt: "Sent"
}
const _hoisted_26 = {
  key: 2,
  class: "read-by-summary"
}
const _hoisted_27 = {
  key: 0,
  src: _imports_1,
  class: "status-icon seen-icon",
  title: "Seen by everyone",
  alt: "Seen by everyone"
}
const _hoisted_28 = {
  key: 1,
  src: _imports_3,
  class: "status-icon sent-icon",
  title: "Not seen by everyone",
  alt: "Not seen by everyone"
}
const _hoisted_29 = { class: "read-count" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Read By ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "read-arrow-icon",
  alt: "View read users"
}, null, -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 3,
  class: "read-by-users"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  src: _imports_1,
  class: "status-icon seen-icon",
  title: "Seen",
  alt: "Seen"
}
const _hoisted_36 = {
  key: 1,
  src: _imports_2,
  class: "status-icon sent-icon",
  title: "Sent",
  alt: "Sent"
}
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 2,
  class: "profile-box"
}
const _hoisted_39 = {
  contenteditable: "false",
  class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "loader-parent"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" }, null, -1 /* HOISTED */)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "d-flex flex-wrap gap-1"
}
const _hoisted_46 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_47 = ["src", "alt", "onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-1" }, null, -1 /* HOISTED */)
const _hoisted_50 = { class: "file-size" }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "m-1 py-2 px-2 file-render text-light d-flex flex-column justify-content-end position-relative" }
const _hoisted_53 = ["href", "onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-1" }, null, -1 /* HOISTED */)
const _hoisted_55 = { class: "file-size" }
const _hoisted_56 = { class: "fw-bold mb-0" }
const _hoisted_57 = { class: "mb-0 file-details" }
const _hoisted_58 = { class: "pe-1" }
const _hoisted_59 = { class: "file-size" }
const _hoisted_60 = {
  key: 0,
  class: "hover-actions-card"
}
const _hoisted_61 = { class: "hover-reactions" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "hover-divider" }, null, -1 /* HOISTED */)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1 /* HOISTED */)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1 /* HOISTED */)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "status-icon"
}, null, -1 /* HOISTED */)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h font-size-lg" }, null, -1 /* HOISTED */)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Not Delivered ")
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", {
  class: "retry-icon",
  src: _imports_8
}, null, -1 /* HOISTED */)
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageInputHandler = _resolveComponent("MessageInputHandler")!
  const _component_Span = _resolveComponent("Span")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!
  const _component_MessageHoverActions = _resolveComponent("MessageHoverActions")!
  const _component_MessageReactions = _resolveComponent("MessageReactions")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_ctx.message.isAutoGenerated)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: `msg-id-${_ctx.message.id}`,
        class: _normalizeClass(["user-message message-body", { grouped: _ctx.shouldHideMessageInfo }])
      }, [
        (_ctx.showEditMsgBox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_MessageInputHandler, {
                "initial-message": _ctx.newMessage,
                "is-important": _ctx.isImportant,
                send: _ctx.sendEditedMsg,
                "toggle-important": _ctx.toggleImportant,
                message: _ctx.initialEditMsg,
                closeEditMsg: _ctx.closeEditMsgDialog,
                "refs-name": _ctx.message.id
              }, null, 8 /* PROPS */, ["initial-message", "is-important", "send", "toggle-important", "message", "closeEditMsg", "refs-name"])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.message.isDeprecated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.showUndoButton)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "undo-msg ps-1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.undoDeletedMsg && _ctx.undoDeletedMsg(...args)))
                  }, "Undo"))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (!_ctx.showEditMsgBox && !_ctx.message.isDeprecated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.shouldHideMessageInfo || _ctx.message.isImportant || _ctx.message.isEdited)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`d-flex message-info w-100 ${
                    _ctx.message.isImportant ? 'justify-content-between' : 'justify-content-end'
                }`)
                  }, [
                    (_ctx.message.isImportant)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " IMPORTANT "))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", null, [
                      (_ctx.message.isEdited)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Edited "))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.shouldHideMessageInfo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formatMessageTime(_ctx.message.createdOn)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_8, [
                _createCommentVNode(" Sending "),
                (_ctx.message.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                (_ctx.message.isImportant)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Content "),
                _createVNode(_component_MessageHoverActions, {
                  ref: "hoverActions",
                  position: "left",
                  "message-id": _ctx.message.id,
                  onHoverClosed: _ctx.closeEmojiPicker
                }, {
                  message: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(`user-message-body highlight-body ${_ctx.message.isError ? 'message-error' : ''}`)
                    }, [
                      _createCommentVNode(" Reply of Message "),
                      (_ctx.message.replyToMessage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "card bg-form-section material-card reply-message-body my-1 cursor-pointer",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReplyMsgNavigation && _ctx.handleReplyMsgNavigation(...args)))
                          }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.message.replyToMessage.senderDetails.firstName) + " " + _toDisplayString(_ctx.message.replyToMessage.senderDetails?.lastName
                                                    ? _ctx.message.replyToMessage.senderDetails?.lastName
                                                    : ""), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatMessageTime(_ctx.message.replyToMessage.createdOn)), 1 /* TEXT */)
                              ])
                            ]),
                            (_ctx.message.replyToMessage.text)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "reply-message-text my-1",
                                  innerHTML: 
                                            _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.formatReplyToMsgText(_ctx.message.replyToMessage)))
                                        
                                }, null, 8 /* PROPS */, _hoisted_19))
                              : (_ctx.replyMsgProfiles)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.replyMsgProfiles, (profile) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: profile.id,
                                        class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                                      }, [
                                        _hoisted_21,
                                        _createElementVNode("span", null, _toDisplayString(profile.name), 1 /* TEXT */)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Reply of Message Ends"),
                      (_ctx.isLastMessage && _ctx.hasTestAgency)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createCommentVNode(" GROUP CONVERSATION "),
                              (_ctx.isGroupConversation)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (
                                                (_ctx.activeConversation.loginIds?.length || 0) > 0 &&
                                                (_ctx.message.readList?.length || 0) ===
                                                    (_ctx.activeConversation.loginIds?.length || 0)
                                            )
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                                    _createCommentVNode(" Read Count "),
                                    (_ctx.showReadCount)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                          _createCommentVNode(" ADD TWO ICONS  "),
                                          (
                                                    (_ctx.activeConversation.loginIds?.length || 0) > 0 &&
                                                    (_ctx.message.readList?.length || 0) ===
                                                        (_ctx.activeConversation.loginIds?.length || 0)
                                                )
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                                            : (_openBlock(), _createElementBlock("img", _hoisted_28)),
                                          _createCommentVNode("  - ONLY this opens Read Users "),
                                          _createElementVNode("span", _hoisted_29, [
                                            _createVNode(_component_Span, null, {
                                              default: _withCtx(() => [
                                                _hoisted_30
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createTextVNode(" " + _toDisplayString((_ctx.message.readList?.length || 0) +
                                                    "/" +
                                                    (_ctx.activeConversation.loginIds?.length || 0)) + " ", 1 /* TEXT */),
                                            ((_ctx.message.readList?.length || 0) > 0)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: "read-users-arrow",
                                                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleReadUsers && _ctx.toggleReadUsers(...args)), ["stop"]))
                                                }, _hoisted_32))
                                              : _createCommentVNode("v-if", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Read Users "),
                                    (_ctx.showReadUsers && _ctx.message.readList?.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.readList || [], (user, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "read-user",
                                              innerHTML: user
                                            }, null, 8 /* PROPS */, _hoisted_34))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" ONE TO ONE CONVERSATION "),
                                    (_ctx.message.readList?.length > 0)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_36))
                                  ], 64 /* STABLE_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", {
                        class: "message-content",
                        innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.formatMsgText()))
                      }, null, 8 /* PROPS */, _hoisted_37),
                      _createCommentVNode(" Shared Profiles "),
                      (_ctx.sharedProfilesList?.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedProfilesList, (profile) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: profile.id,
                                class: "cursor-pointer"
                              }, [
                                _createElementVNode("span", _hoisted_39, [
                                  _hoisted_40,
                                  _createElementVNode("span", {
                                    onClick: (e) => _ctx.getProfileRedirectURL(profile, e)
                                  }, _toDisplayString(profile.name), 9 /* TEXT, PROPS */, _hoisted_41)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Files "),
                      (_ctx.message.assetIds.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (_ctx.assetLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                              : _createCommentVNode("v-if", true),
                            (_ctx.fetchedAssets.length > 0 && !_ctx.assetLoading)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_45, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchedAssets, (assetResponse, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      (_ctx.isImage(assetResponse.asset.mimeType))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            _createElementVNode("img", {
                                              class: _normalizeClass(`image my-2 ${
                                                        assetResponse.asset.showDownloadBtn ? 'image-blur' : ''
                                                    }`),
                                              src: assetResponse.asset.url,
                                              alt: assetResponse.asset.fileName,
                                              onClick: 
                                                        (e) =>
                                                            _ctx.showImageOverlay(
                                                                index,
                                                                !assetResponse.asset.showDownloadBtn,
                                                                e
                                                            )
                                                    
                                            }, null, 10 /* CLASS, PROPS */, _hoisted_47),
                                            (assetResponse.asset.showDownloadBtn)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  href: "javascript:void(0);",
                                                  class: "img-download-btn",
                                                  onClick: (e) => _ctx.downloadAsset(assetResponse.asset, e)
                                                }, [
                                                  _hoisted_49,
                                                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_48))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _createElementVNode("a", {
                                                class: "file-download",
                                                href: assetResponse.asset.url,
                                                onClick: (e) => _ctx.downloadAsset(assetResponse.asset, e)
                                              }, [
                                                _hoisted_54,
                                                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                              ], 8 /* PROPS */, _hoisted_53),
                                              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.truncateString(assetResponse.asset.fileName.split(".")[0], 45)), 1 /* TEXT */),
                                              _createElementVNode("p", _hoisted_57, [
                                                _createElementVNode("span", _hoisted_58, _toDisplayString(assetResponse.asset.fileName.split(".").pop().toUpperCase()), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                              ])
                                            ])
                                          ]))
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */)
                  ]),
                  actions: _withCtx(() => [
                    (!_ctx.showReadCount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createCommentVNode(" Emoji quick reactions "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultQuickReactions, (emoji) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: emoji,
                                class: "reactions-btn",
                                onClick: ($event: any) => (_ctx.handleEmoji(emoji))
                              }, _toDisplayString(emoji), 9 /* TEXT, PROPS */, _hoisted_62))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createCommentVNode(" Emoji picker "),
                            _createElementVNode("div", {
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_EmojiPicker, {
                                isHover: true,
                                ref: "emojiPicker",
                                onEmojiSelected: _ctx.handleEmoji
                              }, null, 8 /* PROPS */, ["onEmojiSelected"])
                            ]),
                            _createCommentVNode(" Divider "),
                            _hoisted_63,
                            _createCommentVNode(" Edit "),
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              class: "hover-action-btn",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.editMessage && _ctx.editMessage(...args)))
                            }, _hoisted_65)), [
                              [_directive_tooltip, { title: `Edit`, placement: 'top' }]
                            ]),
                            _createCommentVNode(" Reply "),
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              class: "hover-action-btn",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.replyToMessage && _ctx.replyToMessage(...args)))
                            }, _hoisted_67)), [
                              [_directive_tooltip, { title: `Reply`, placement: 'top' }]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              class: "hover-action-btn delete-btn",
                              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteMessage && _ctx.deleteMessage(...args)), ["stop"]))
                            }, _hoisted_69)), [
                              [_directive_tooltip, { title: 'Delete', placement: 'top' }]
                            ]),
                            _createCommentVNode(" More "),
                            (_ctx.isGroupConversation && _ctx.isLastMessage && _ctx.hasTestAgency)
                              ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "hover-action-btn",
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleReadCount && _ctx.toggleReadCount(...args)), ["stop"]))
                                }, _hoisted_71)), [
                                  [_directive_tooltip, { placement: 'top' }]
                                ])
                              : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["message-id", "onHoverClosed"])
              ]),
              _createVNode(_component_MessageReactions, { message: _ctx.message }, null, 8 /* PROPS */, ["message"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (!_ctx.message.isLoading && _ctx.message.isError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-xs py-0 retry-btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.retryMessage(_ctx.message)))
              }, _hoisted_75)
            ]))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}